import { render, staticRenderFns } from "./HeaderCard.vue?vue&type=template&id=8f42974a&"
import script from "./HeaderCard.vue?vue&type=script&lang=js&"
export * from "./HeaderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports